module.exports = __webpack_public_path__ + "static/media/Live.34602a94.svg";